import { render, staticRenderFns } from "./Xsbg.vue?vue&type=template&id=666ae572&"
import script from "./Xsbg.vue?vue&type=script&lang=js&"
export * from "./Xsbg.vue?vue&type=script&lang=js&"
import style0 from "./Xsbg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports